import React, { useEffect, useRef, useState } from 'react';
import "../../BREComponent/BRETable/BRETable.css";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import halflines from "../../../Assets/halflines.svg";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  Select,
  OutlinedInput,
  MenuItem
} from '@mui/material';
import sortingimg from "../../../Assets/sortingarrow.svg";
import eyebre from "../../../Assets/eyebre.svg";
import eyebreopened from "../../../Assets/eyebreopened.svg";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import neweventslogo from "../../../Assets/neweventslogo.svg"
import moment from 'moment';
import LocationTableBRE from './LocationTableBRE';
import FinancialTable from './FinancialTable';
import NewsEventsBre from './NewsEventsBre';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import excellogo from "../../../Assets/excellogobre.svg";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
import { useNavigate } from 'react-router-dom';
const BrePdfAllTabs = ({ PDFSelectedData, downloadToPDF, contentRef }) => {
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const initialData = (item) => {
    const data = item?.split(" ")
    return `${data?.[0]?.charAt(0).toUpperCase() || ""}${data?.[1]?.charAt(0).toUpperCase() || ""}`
  }
  // style={{ pageBreakInside: "avoid", breakBefore: 'page' }}
  return (
    <TableContainer component={Paper} className='bre-tc-outer' ref={contentRef} style={{ pageBreakInside: "avoid"}}>
      {
        PDFSelectedData?.map((item, index) => (
          <Table>
            <TableHead>
              <TableRow style={{ width: '100%' }}>
                <TableCell style={{ width: '6%' }}><p className='bre-table-th'> Select</p></TableCell>
                <TableCell style={{ width: '22%' }}><p className='bre-table-th'>Company
                  <img
                    src={sortingimg}
                    alt=""
                    className="sorting-arrow-leadsprofile"
                  /></p></TableCell>
                <TableCell style={{ width: '18%' }}><p className='bre-table-th'>JO Sector
                  <img
                    src={sortingimg}
                    alt=""
                    className="sorting-arrow-leadsprofile"
                  /></p></TableCell>
                <TableCell style={{ width: '15%' }}><p className='bre-table-th'>Employment
                  <img
                    src={sortingimg}
                    alt=""
                    className="sorting-arrow-leadsprofile"
                  /></p></TableCell>
                <TableCell style={{ width: '10%' }}><p className='bre-table-th'>Revenue
                  <img
                    src={sortingimg}
                    alt=""
                    className="sorting-arrow-leadsprofile"
                  /></p></TableCell>
                <TableCell style={{ width: '20%' }}><p className='bre-table-th'>Last Recorded BRE
                  <img
                    src={sortingimg}
                    alt=""
                    className="sorting-arrow-leadsprofile"
                  /></p></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <React.Fragment>
                <TableRow>
                  <TableCell><p className='bre-table-tr'> <input type="checkbox" style={{ cursor: 'pointer' }} checked={true} /></p></TableCell>
                  <TableCell><p className='bre-table-tr' style={{ cursor: 'pointer' }} >{item?.od?.account_name}</p></TableCell>
                  <TableCell><p className='bre-table-tr'>{item?.od?.org_industry}</p></TableCell>
                  <TableCell><p className='bre-table-tr'>{item?.od?.org_num_employees}</p></TableCell>
                  <TableCell><p className='bre-table-tr'>{item?.od?.org_revenue_range}</p></TableCell>
                  <TableCell><p className='bre-table-tr'>{moment(item?.od?.org_date).format('MM/DD/YYYY')}<br /> {item?.od?.last_recorded_bre}</p></TableCell>
                  <TableCell >
                    <p className='bre-table-tr-eye'>
                      <img src={eyebreopened} alt="eye-icon" />
                    </p>
                  </TableCell>
                </TableRow>
                <TableRow className='trow-BRE-tabs'>
                  <TableCell colSpan={7} style={{ padding: 0 }}>
                    <Box sx={{ width: '100%', backgroundColor: '#f9f9f9' }} style={{ pageBreakInside: "avoid" }}>
                      <>
                        <>
                          <Box sx={{ borderBottom: 1, borderColor: 'divider' }} style={{ pageBreakInside: "avoid", display: "flex", flexDirection: "column", alignItems: "start" }}>
                            <Tabs aria-label="BRE detail tabs">
                              <Tab
                                label={
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <LocationOnOutlinedIcon fontSize="small" />
                                    Locations
                                  </span>
                                }
                                {...a11yProps(0)}
                              />
                            </Tabs>
                          </Box>
                          <div ><LocationTableBRE locationTableData={item?.ld} style={{ pageBreakInside: "avoid"}} /></div>
                        </>
                        <>
                          <Box sx={{ borderBottom: 1, borderColor: 'divider' }} style={{ pageBreakInside: "avoid", breakBefore: 'page', display: "flex", flexDirection: "column", alignItems: "start" }}>
                            <Tabs aria-label="BRE detail tabs">
                              <Tab
                                label={
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <AttachMoneyOutlinedIcon fontSize="small" />
                                    Financial Metrics
                                  </span>
                                }
                                {...a11yProps(1)}
                              />
                            </Tabs>
                          </Box>
                          <FinancialTable financialTableData={item?.fd} downloadToPDF={downloadToPDF} />
                        </>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} style={{ pageBreakInside: "avoid", display: "flex", flexDirection: "column", alignItems: "start" }}>
                          <Tabs aria-label="BRE detail tabs">
                            <Tab
                              label={
                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <img src={neweventslogo} alt="" />
                                  News/Events
                                </span>
                              }
                              {...a11yProps(2)}
                            />
                          </Tabs>
                          <div className='add-contents-cards-bre'>
                            {
                              item?.nd?.length ?
                                <div className='CI-cards-content-bre' style={{ pageBreakInside: "avoid" }}>
                                  <div className='adding-content' style={{ pageBreakInside: "avoid" }}>
                                    <div className='two-head-comp'>
                                      <div className='result-date-icon-comp-bre' style={{ pageBreakInside: "avoid" }}>
                                        <div className='checkbox-result-tag-comp'>
                                          <img src={halflines} alt="" />
                                          <p className='sorted-by-comp'>Sorted by:</p>
                                          <div className='acc-dec-btn-main-bre'>
                                            <FormControl sx={{ m: 1, minWidth: 120 }} className='date-comp-dropdown'>
                                              <Select className='date-comp-select'
                                                value={"desc"}
                                                displayEmpty
                                                input={<OutlinedInput
                                                  notched={false}
                                                  classes={{ notchedOutline: 'custom-fieldset-class', input: 'custom-select-input-class' }}
                                                />}
                                                inputProps={{ 'aria-label': 'Without label' }}
                                              >
                                                <MenuItem value="asc" className='date-comp-em'>Ascending </MenuItem>
                                                <MenuItem value="desc" className='date-comp-em'>Descending </MenuItem>
                                              </Select>
                                            </FormControl>
                                          </div>
                                          <div className='total-result-brenews'>{item?.nd?.length} {item?.nd?.length < 2 ? "Result" : "Results"}</div>
                                        </div>
                                      </div>
                                    </div>
                                    <div >
                                      {item?.nd?.length ? <>
                                        {item?.nd?.map((articleData, index) => (
                                          <div key={index} className='rest-cont' style={{ pageBreakInside: "avoid" }}>
                                            <div className='joi-circle-text-comp'>
                                              <div className='jo-icon-comp'><p>{item?.od?.org_name ? initialData(item?.od?.org_name) : item?.od?.org_name}</p></div>
                                              <div className='date-name-csoon'>
                                                <div><p className='jobsohio-name-comp'>{articleData?.article?.title?.length > 100
                                                  ? articleData?.article?.title.slice(0, articleData?.article?.title.slice(0, 100).lastIndexOf(" ")) + "..."
                                                  : articleData?.article?.title}
                                                </p></div>
                                                <div className="both-news-time-comp">
                                                  <p className="news-comp">
                                                    <a
                                                      href={articleData?.article?.url}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      {
                                                        articleData?.article?.url
                                                          ? (articleData.article.url.split('https://')[1]?.length > 50
                                                            ? articleData.article.url.split('https://')[1].slice(0, 50) + '...'
                                                            : articleData.article.url.split('https://')[1])
                                                          : ''
                                                      }
                                                    </a>
                                                    |
                                                  </p>
                                                  <p className="today-comp">
                                                    {new Date(
                                                      articleData?.article?.date
                                                    ).toLocaleDateString("en-US", {
                                                      month: "long",
                                                      day: "numeric",
                                                      year: "numeric",
                                                    })}
                                                    {/* {articleData?.article?.date} */}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div className='content-pera-comp'>
                                              <p className="bold-content-pera-comp">
                                                {articleData?.summary}
                                              </p>
                                              <div className="Intersect-jb-nf-comp">
                                                {articleData?.tags?.map((tag, idx) => (
                                                  <p key={idx}>{tag}</p>
                                                ))}
                                              </div>
                                            </div>
                                            <hr className='hr-tag-ci' />
                                          </div>
                                        ))}
                                      </> : <p className='text-center-result'>No results found</p>}
                                    </div>
                                  </div>
                                </div> : <div className='CI-cards-content'><div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>Data Not Available </div></div>
                            }
                          </div>
                        </Box>
                      </>
                    </Box>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            </TableBody>
          </Table>
        ))
      }
    </TableContainer>
  )
}
export default BrePdfAllTabs
